export default __webpack_public_path__ + "static/media/cross-button.11cca638.svg";